export const downloadDoc = (url, name) => {
	const link = document.createElement('a');
	link.href = url;
	link.setAttribute('download', `${name}.pdf`);
	document.body.appendChild(link);
	link.click();
	link.parentNode.removeChild(link);
};
